import { map, reject } from 'lodash';
import { handleActions } from 'redux-actions';
import { CorporateUser } from '@models/User';
import { ImportModel } from '@models/ImportModel';
import {
  State,
  stateUpdate,
  StateUpdatePayload,
  corporateHealthQuoteGetUsersSuccess,
  corporateHealthQuoteUpdateUserSuccess,
  corporateHealthQuoteDeleteUserSuccess,
  corporateHealthQuoteCreateImportSuccess,
} from './action';

const initialState: State = {
  users: [],
  isUsersLoading: false,
  usersPagination: null,
  imports: [],
};

const reducer = handleActions(
  {
    [String(corporateHealthQuoteGetUsersSuccess)]: (state, { payload }) => {
      const { users, usersPagination } = payload as unknown as StateUpdatePayload;
      return {
        ...state,
        users,
        isUsersLoading: false,
        usersPagination,
      };
    },

    [String(corporateHealthQuoteUpdateUserSuccess)]: (state, { payload }) => {
      const updatedUser = payload as unknown as CorporateUser;
      return {
        ...state,
        users: map(state.users, user => user.id === updatedUser.id ? updatedUser : user),
      };
    },

    [String(corporateHealthQuoteDeleteUserSuccess)]: (state, { payload }) => {
      const userId = payload as unknown as number;
      return {
        ...state,
        users: reject(state.users, ({ id }) => id === userId),
      };
    },

    [String(corporateHealthQuoteCreateImportSuccess)]: (state, { payload }) => {
      const newImport = payload as unknown as ImportModel;
      return {
        ...state,
        imports: [...state.imports, newImport],
      };
    },

    [String(stateUpdate)]: (state, { payload }) => {
      return {
        ...state,
        ...payload,
      };
    },
  },

  initialState,
);

export default reducer;
